import Config from '../private/config'

export const { REACT_APP_URL } = window.config
export const { REACT_APP_SERVICE_PUBLIC_API } = window.config
export const { REACT_APP_SERVICE_PUBLIC_API_V2 } = window.config
export const { REACT_APP_SERVICE_API } = window.config
export const { REACT_APP_IMAGESERVICE_API } = window.config
export const { REACT_APP_GOOGLE_API_KEY } = Config
export const { REACT_APP_GOOGLE_CAPTCHA_KEY } = Config
export const { REACT_APP_PROJECT_SERVICE_API } = window.config
export const { REACT_APP_REFINER_PROJECT_ID } = window.config
export const { REACT_APP_REFINER_FORM_ID } = window.config
export const { LOGIN_AXONS_ONE } = window.config
export const { REACT_APP_AXONS_ONE_APP_ID } = window.config
export const { REACT_APP_AXONS_ONE_TENANT } = window.config
export const { REACT_APP_BASE_API_URL_AXONS_CLOUD } = window.config
export const DEPLOY_ENV = window.config?.DEPLOY_ENV || 'development'

/*
 * The docker template wraps every value in quotes (`.docker/config.js.template`), so a flag
 * arrives as the STRING 'true' / 'false' — and 'false' is truthy. Parse it once here rather
 * than letting each call site decide.
 */
const toBool = (value) => value === true || value === 'true'

/** Serve the Sprint 81 project list (`/v2/project-list`) at the root path instead of the Gantt tabs. */
export const PROJECT_LIST_V2 = toBool(window.config?.REACT_APP_PROJECT_LIST_V2)

/**
 * Sidebar entries that stay off unless the value is exactly `true`.
 * The routes themselves stay registered, so a direct link still opens the page.
 */
export const MENU_INBOX_VISIBLE = toBool(window.config?.REACT_APP_MENU_INBOX_VISIBLE)
export const MENU_HISTORY_VISIBLE = toBool(window.config?.REACT_APP_MENU_HISTORY_VISIBLE)
export const MENU_PROFESSIONAL_SKILL_VISIBLE = toBool(
  window.config?.REACT_APP_MENU_PROFESSIONAL_SKILL_VISIBLE,
)
